import { post } from "../utils/backend";
import { compressFileToJpegBase64 } from "../utils/imageCompressToJpeg";
import { useLongfansMock } from "../global/GlobalMock";
import { mockUpdateProfile, mockUploadAvatarBase64 } from "./UserProfileMock";

export type UpdateProfileParam = {
  nickname: string;
  /** 自助填写的图片地址，对应 customer.avatar_url */
  avatarUrl: string;
  /** M 男 F 女 U 未选 */
  gender: string;
  /** 公历 yyyy-MM-dd，空表示不填 */
  birthday: string;
};

const updateProfile = async (p: UpdateProfileParam): Promise<boolean> => {
  if (useLongfansMock) {
    return mockUpdateProfile(p);
  }
  const res = await post<UpdateProfileParam, boolean>("/api/user/updateProfile", {
    nickname: p.nickname.trim(),
    avatarUrl: p.avatarUrl.trim(),
    gender: p.gender,
    birthday: p.birthday.trim(),
  });
  if (typeof res === "string") {
    return false;
  }
  return !!res;
};

const uploadAvatarFromCompressedFile = async (file: File): Promise<string | null> => {
  if (useLongfansMock) {
    return mockUploadAvatarBase64();
  }
  let base64Data: string;
  try {
    base64Data = await compressFileToJpegBase64(file, 640, 0.86);
  } catch {
    return null;
  }
  const res = await post<
    { base64Data: string },
    { avatarUrl: string }
  >("/api/user/uploadAvatarBase64", { base64Data });
  if (typeof res === "string" || !res?.avatarUrl) {
    return null;
  }
  return res.avatarUrl;
};

export const UserProfileApi = {
  updateProfile,
  uploadAvatarFromCompressedFile,
};
